module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('v-header', {
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('v-nav', {
    on: {
      "showlogin": _vm.showLogin
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    on: {
      "showlogin": _vm.showLogin,
      "showregist": _vm.showRegist
    }
  })], 1), _vm._v(" "), _c('login-dialog', {
    ref: "login",
    on: {
      "showregist": _vm.showRegist
    }
  }), _vm._v(" "), _c('regist', {
    ref: "regist"
  }), _vm._v(" "), _c('v-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-302c79b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home.vue
// module id = 623
// module chunks = 31